module.exports = __webpack_public_path__ + "static/img/main_calendar_icon_g.28f2ce18.svg";